export enum ComparableResult {
    less = -1,
    equal = 0,
    greater = 1,
}

export type Comparable<TRowData> = (left: TRowData, right: TRowData) => ComparableResult;
